<div class="container-fluid">
<section>
	<header style="margin-top: 15px;">
		<h4 class="mb-3">
			<span jhiTranslate="about.title">Brought to you by </span>
			<img src="content/images/logoFull.jpg" style="width: 220px;"/>
		</h4>
	</header>
	<div class="row mb-3">
		<p></p>
		<section class="col">
			<h4>
				<span jhiTranslate="about.version">Version</span>
			</h4>
			<span jhiTranslate="about.breeding.management.system">Breeding Management System</span><a href (click)="openReleaseNote($event)">{{version}}</a>
		</section>
	</div>
	<div class="row mb-3">
		<section class="col">
			<a href="https://integratedbreeding.net/1852/our-people/dev-partners" target="_blank"><h4 class="about-header" jhiTranslate="about.dev.partners">Dev Partners</h4></a>
		</section>
	</div>
	<div class="row mb-3">
		<section class="col">
			<a href="https://integratedbreeding.net/1854/facilitators" target="_blank"><h4 class="about-header" jhiTranslate="about.facilitators">Facilitators</h4></a>
		</section>
	</div>
</section>
</div>
